import Vue from 'vue';
import Vuetify from 'vuetify/lib';

/*// Translation provided by Vuetify (typescript)
import fa from 'vuetify/src/locale/fa'*/

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    }, rtl: true,
});
